import _ from 'lodash'
import { getAppPathname, getSigninUrl, isAuthLocation } from '@/Utils/authRedirect'
import { resetAnalytics } from '@/lib/tracking'

const defaultState = () => ({
	token: null,
	isAuthenticated: false
});

const state = defaultState();

const mutations = {
	AUTH_SET_IS_AUTHENTICATED(state, isAuthenticated) {
		state.isAuthenticated = isAuthenticated;
	},
	AUTH_SET_TOKEN(state, token) {
		state.token = token;
	}
};

const actions = {
	setIsAuthenticated({ commit }, isAuthenticated) {
		commit('AUTH_SET_IS_AUTHENTICATED', isAuthenticated);
	},
	async login({ commit, dispatch }) {
		// if not logged in redirect to login-page
		const token = window.localStorage.getItem('token');
		if(!_.isEmpty(token)) {
			commit('AUTH_SET_TOKEN', token);
			commit('AUTH_SET_IS_AUTHENTICATED', true);
			// Don't load user here - let App.vue handle data loading
		}
		const { href } = window.location;
		if (!token && !isAuthLocation(href))  {
			setTimeout(() => {
				console.log('auth redirect: vuex');
				window.location.href = getSigninUrl();
			});
			return;
		}
	},
	logout({ commit, dispatch }) {
		const { href } = window.location;
		if (getAppPathname(href).toLowerCase() === '/two-factor-verification') return
		
		window.localStorage.removeItem('user');
		window.localStorage.removeItem('token');
		window.localStorage.removeItem('twoFactorValidated');
		window.localStorage.removeItem('twoFactorRequired');
		commit('AUTH_SET_TOKEN', false);
		commit('AUTH_SET_IS_AUTHENTICATED', false);
		dispatch('User/unloadUser', null, { root: true });
		resetAnalytics();

		// if current is not an AUTH page
		// const { href } = window.location;
		// if (!/login|signin|signup/gi.test(href)) {
		// 	setTimeout(() => {
		// 		window.location.href = '/signin';
		// 	}, 100);
		// }
	}
};

const getters = {
	isLoggedIn: state => !!state.token,
	authStatus: state => state.isAuthenticated,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
